import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

const useSetDocumentTitle = (title: string) => {
  const loc = useLocation();
  useEffect(() => {
    document.title = title;
  }, [loc]);
};

export default useSetDocumentTitle;